import Konva from "konva";
import * as _ from 'lodash';
import { collapseIndexForPanelPage, detailsOfNonUsableAreas, resetPanelShowForPanelPage } from '../../store/senAppProjects.action';
import { ScaleAdjustmentValue } from '../getScaleFactor';
import { getListbyBlocks } from "../mountsys/PanelRowManager";
import { DrawRoofForPanel } from "../panel/drawRoofForPanel";
import { ModGroup } from '../panel/ModGroup';
import { ModList } from '../panel/ModList';
import { Modul } from '../panel/Modul';
import genaratePanelSave, { saveNonUsableAreas } from '../panel/savePanelDetails';
import { Global } from "../utilities/global";
import { FenceCircle } from "./FenceCircle";
import { FenceRectangle } from "./FenceRectangle";
import { FenceStatic } from "./FenceStatic";
import { FenceTriangle } from "./FenceTriangle";
import { ShapeDetails } from "./shapeDetails";
import { Shape } from "./ShapeInterface";

declare var turf: any;
export class DrawFence {

    typeOfShape: string = "";
    layer: any;
    selectedShape: Shape;
    static storeObj: any = null;
    // static listOfFence = [];
    static FenceCount: number = 0;
    static fillColor: string = '#443939';
    static currentSelectedShape: any = null;
    static selectedShape: any;
    static drawShapeEnable: any = false;
    static drawShapeRef: any = null;
    static shapeDragging: boolean = false;
    static doClearPanels: boolean = false;

    static isTransformEnabled: any = false;
    //static p5: any;

    //for disable slection on drag and drop triangle points
    static selectPotionRect = true;
    //static isMovedTriangle = false;

    crateNewShape(type: string) {
        // console.log(type);
        this.typeOfShape = type;
        if (type == 'rectangle')
            DrawFence.drawShapeRef = new FenceRectangle();
        if (type == 'triangle')
            DrawFence.drawShapeRef = new FenceTriangle();
        if (type == 'circle')
            DrawFence.drawShapeRef = new FenceCircle();
        // this.allowToDrawShape();
        DrawFence.drawShapeEnable = true;
    }

    //draw obstructions from saved
    static drawFenceFromSaved(group: any) {
        group.forEach((shape: any) => {
            let shapObj: any = null;
            if (shape.type == FenceStatic.TRIANGLE) {
                const p: number[] = [
                    ScaleAdjustmentValue.getScaleAdjust(shape.x1),
                    ScaleAdjustmentValue.getScaleAdjust(shape.y1),
                    ScaleAdjustmentValue.getScaleAdjust(shape.x2),
                    ScaleAdjustmentValue.getScaleAdjust(shape.y2),
                    ScaleAdjustmentValue.getScaleAdjust(shape.x3),
                    ScaleAdjustmentValue.getScaleAdjust(shape.y3),
                ]

                shapObj = new FenceTriangle().getTriangle(null, null, shape.name, p);
            } else if (shape.type == FenceStatic.RECTANGLE) {
                // console.log(shape)
                try {
                    if (shape.width) {
                        shapObj = new FenceRectangle().drawShape({ x: ScaleAdjustmentValue.getScaleAdjust(shape.x1), y: ScaleAdjustmentValue.getScaleAdjust(shape.y1) }, { x: ScaleAdjustmentValue.getScaleAdjust(shape.x1 + shape.width), y: ScaleAdjustmentValue.getScaleAdjust(shape.y1 + shape.height) }, shape.name);
                    } else {
                        shapObj = new FenceRectangle().drawShape(null, null, shape.name, [ScaleAdjustmentValue.getScaleAdjust(shape.x1), ScaleAdjustmentValue.getScaleAdjust(shape.y1), ScaleAdjustmentValue.getScaleAdjust(shape.x2), ScaleAdjustmentValue.getScaleAdjust(shape.y2), ScaleAdjustmentValue.getScaleAdjust(shape.x3), ScaleAdjustmentValue.getScaleAdjust(shape.y3), ScaleAdjustmentValue.getScaleAdjust(shape.x4), ScaleAdjustmentValue.getScaleAdjust(shape.y4)]);
                    }
                } catch (err) {

                }
            } else {
                shapObj = new FenceCircle().getCircle(ScaleAdjustmentValue.getScaleAdjust(shape.x1), ScaleAdjustmentValue.getScaleAdjust(shape.y1), shape.radius, Global.nonUsableArea, shape.name);
            }
            if (shapObj) {
                DrawFence.bindEventsForShape(shapObj);
                DrawRoofForPanel.layerPanel.add(shapObj);
            }
        })
        DrawRoofForPanel.layerPanel.draw();
        //saving globally to maintain prev and next state 
        saveNonUsableAreas();
    }
    // Bind mouse events to draw Shapes
    allowToDrawShape() {
    }

    static bindEventsForShape(shape: any) {
        const textX1 = new Konva.Text({
            x: 0,
            y: 0,
            text: "X: ",
            fontSize: 30,
            fontFamily: 'intro',
            fill: "#fff",
            name: "obstructionText",
            shadowColor: 'white',
            shadowBlur: 10,
            shadowOffsetX: 10,
            shadowOffsetY: 10,
            shadowOpacity: 0.5,

        });
        const textY1 = new Konva.Text({
            x: 0,
            y: 0,
            text: "Y: ",
            fontSize: 30,
            fontFamily: 'intro',
            fill: "#fff",
            name: "obstructionText",
            shadowColor: 'white',
            shadowBlur: 10,
            shadowOffsetX: 10,
            shadowOffsetY: 10,
            shadowOpacity: 0.5,

        });
        const textX2 = new Konva.Text({
            x: 0,
            y: 0,
            text: "X: ",
            fontSize: 30,
            fontFamily: 'intro',
            fill: "#fff",
            name: "obstructionText",
            shadowColor: 'white',
            shadowBlur: 10,
            shadowOffsetX: 10,
            shadowOffsetY: 10,
            shadowOpacity: 0.5,

        });
        const textY2 = new Konva.Text({
            x: 0,
            y: 0,
            text: "Y: ",
            fontSize: 30,
            fontFamily: 'intro',
            fill: "#fff",
            name: "obstructionText",
            shadowColor: 'white',
            shadowBlur: 10,
            shadowOffsetX: 10,
            shadowOffsetY: 10,
            shadowOpacity: 0.5,

        });
        const textX3 = new Konva.Text({
            x: 0,
            y: 0,
            text: "X: ",
            fontSize: 30,
            fontFamily: 'intro',
            fill: "#fff",
            name: "obstructionText",
            shadowColor: 'white',
            shadowBlur: 10,
            shadowOffsetX: 10,
            shadowOffsetY: 10,
            shadowOpacity: 0.5,

        });
        const textY3 = new Konva.Text({
            x: 0,
            y: 0,
            text: "Y: ",
            fontSize: 30,
            fontFamily: 'intro',
            fill: "#fff",
            name: "obstructionText",
            shadowColor: 'white',
            shadowBlur: 10,
            shadowOffsetX: 10,
            shadowOffsetY: 10,
            shadowOpacity: 0.5,

        });
        const textWidth = new Konva.Text({
            x: 0,
            y: 0,
            text: "Y: ",
            fontSize: 30,
            fontFamily: 'intro',
            fill: "#fff",
            name: "obstructionText",
            shadowColor: 'white',
            shadowBlur: 10,
            shadowOffsetX: 10,
            shadowOffsetY: 10,
            shadowOpacity: 0.5,

        });
        const textHeight = new Konva.Text({
            x: 0,
            y: 0,
            text: "Y: ",
            fontSize: 30,
            fontFamily: 'intro',
            fill: "#fff",
            name: "obstructionText",
            shadowColor: 'white',
            shadowBlur: 10,
            shadowOffsetX: 10,
            shadowOffsetY: 10,
            shadowOpacity: 0.5,

        });


        const textDiameter = new Konva.Text({
            x: 0,
            y: 0,
            text: "Diameter: ",
            fontSize: 30,
            fontFamily: 'intro',
            fill: "#fff",
            name: "obstructionText",
            shadowColor: 'white',
            shadowBlur: 10,
            shadowOffsetX: 10,
            shadowOffsetY: 10,
            shadowOpacity: 0.5,

        });

        const centerPointCirle = new Konva.Circle({
            x: 0,
            y: 0,
            stroke: '#666',
            fill: 'red',
            strokeWidth: 2,
            radius: 12,
            name: "obstructionCirclePoints",
            draggable: false,
            dragOnTop: false,


        });
        const toprectCircle = new Konva.Circle({
            x: 0,
            y: 0,
            stroke: '#666',
            fill: 'red',
            strokeWidth: 2,
            radius: 12,
            name: "obstructionCirclePoints",
            draggable: false,
            dragOnTop: false,

        });
        const bottomrectCircle = new Konva.Circle({
            x: 0,
            y: 0,
            stroke: '#666',
            fill: 'red',
            strokeWidth: 2,
            radius: 12,
            name: "obstructionCirclePoints",
            draggable: false,
            dragOnTop: false,

        });

        const toptrianCircle = new Konva.Circle({
            x: 0,
            y: 0,
            stroke: '#666',
            fill: 'red',
            strokeWidth: 2,
            radius: 20,
            name: "obstructionCirclePoints",
            draggable: false,
            //dragOnTop: false,

        });
        const btmlfttrianCircle = new Konva.Circle({
            x: 0,
            y: 0,
            stroke: '#666',
            fill: 'red',
            strokeWidth: 2,
            radius: 20,
            name: "obstructionCirclePoints",
            draggable: false,
            //dragOnTop: false,

        });

        const btmrgttrianCircle = new Konva.Circle({
            x: 0,
            y: 0,
            stroke: '#666',
            fill: 'red',
            strokeWidth: 2,
            radius: 20,
            name: "obstructionCirclePoints",
            draggable: false,
            //dragOnTop: false,

        });

        shape.on('transform', (evt: any) => {
            DrawFence.updateShapeDetails(shape);
        });

        // console.log(shape);
        shape.on("mousedown", (evt: any) => {
            if (!DrawRoofForPanel.enableDragLayout)
                evt.cancelBubble = true;
        });
        shape.on("mouseenter", () => {
            shape.setStrokeWidth(1);
            DrawRoofForPanel.layerPanel.batchDraw();
        });
        shape.on("mouseleave", () => {
            shape.setStrokeWidth(0);
            DrawRoofForPanel.layerPanel.batchDraw();
        });
        shape.on("dragmove", () => {
            this.clearObstructionTextIfAlreadyPresent();
            this.updateTextWithCoordinates(shape, textX1, textY1, textX2, textY2
                , textX3, textY3, textHeight, textWidth, textDiameter, centerPointCirle, toprectCircle
                , bottomrectCircle, toptrianCircle, btmlfttrianCircle, btmrgttrianCircle);

        });
        shape.on("dragstart", () => {
            // console.log('shape on dragstart',shape.getPoints());

        });
        shape.on
        shape.on("dragend", (evt: any) => {
            if (!DrawRoofForPanel.enableDragLayout) {
                evt.cancelBubble = true;
                // console.log('dragend updateShapeDetails');
                //console.log('shape on dragend',shape.getPoints());
                this.clearObstructionTextIfAlreadyPresent();
                // this.updateTextWithCoordinates(shape, textX1, textY1, textX2, textY2
                //     , textX3, textY3, textHeight, textWidth, textDiameter,centerPointCirle,toprectCircle
                //     ,bottomrectCircle,toptrianCircle,btmlfttrianCircle,btmrgttrianCircle
                //     );
                this.updateShapeDetails(shape);
                // DrawFence.clearPanels();
                DrawFence.isTransformEnabled = false;
                //DrawFence.isMovedTriangle = true;
                DrawFence.clearPanelsForShape(null, null, shape)
                DrawFence.storeObj.dispatch(collapseIndexForPanelPage({ collapseIndex: 3 }));
                this.removeTransformNodes();

                //  

            }
        });
        shape.on("click", () => {
            //console.log('on click obstruction');
            if (!DrawRoofForPanel.enableDragLayout) {
                //console.log('shape',shape);
                //if(DrawFence.isMovedTriangle){
                //  DrawFence.isMovedTriangle = false;
                //   DrawFence.updateShapeDetailForTriangleReshape(shape, -9999,-9999,null);
                // }

                //clear text if already present
                this.clearObstructionTextIfAlreadyPresent();

                //draw coordinates for obstruction

                this.updateTextWithCoordinates(shape, textX1, textY1, textX2, textY2
                    , textX3, textY3, textHeight, textWidth, textDiameter, centerPointCirle, toprectCircle
                    , bottomrectCircle, toptrianCircle, btmlfttrianCircle, btmrgttrianCircle);


                //console.log('draw obstrctions coordinates');


                //on click on obstruction disable subframe view
                DrawFence.storeObj.dispatch(resetPanelShowForPanelPage({ resetPanelShow: true }));

                DrawFence.storeObj.dispatch(collapseIndexForPanelPage({ collapseIndex: 3 }));
                setTimeout(() => {
                    this.addTransformNodes(shape, textX1, textY1, textX2, textY2
                        , textX3, textY3, textHeight, textWidth, textDiameter, centerPointCirle, toprectCircle
                        , bottomrectCircle, toptrianCircle, btmlfttrianCircle, btmrgttrianCircle);
                }, 100);
                this.updateShapeDetails(shape);
                DrawFence.currentSelectedShape = shape;
                DrawFence.selectedShape = shape;

                // remove panel selection if already selected 
                if (ModList.currentSelectedPanel) {
                    Modul.deselection();
                }
                if (ModGroup.currentSelectedGroup) {
                    ModGroup.moveBackToMainGroup();
                }
                DrawRoofForPanel.layerPanel.batchDraw();
            }
        });

        var start = {
            x: 0,
            y: 0
        };
        var end = {
            x: 0,
            y: 0
        };
        var position: any;
        const con = document.getElementById("roof_panel_canvas_container");
        toptrianCircle.on("mousedown", (evt: any) => {
            //onsole.log('entered mousedown toptrianCircle');
            var mousePos: any = DrawRoofForPanel.stage.getPointerPosition();
            start.x = ((mousePos.x) - DrawRoofForPanel.stage.x()) / DrawRoofForPanel.stage.scaleX();
            start.y = ((mousePos.y) - DrawRoofForPanel.stage.y()) / DrawRoofForPanel.stage.scaleY();
            //console.log('toptrianCircle start',start);
            DrawFence.selectPotionRect = false;
            if (con) {
                con.classList.add("sen-cursor-move");
            }

            position = "top";
        });

        btmrgttrianCircle.on("mousedown", (evt: any) => {
            //console.log('entered mousedown toptrianCircle');
            var mousePos: any = DrawRoofForPanel.stage.getPointerPosition();
            start.x = ((mousePos.x) - DrawRoofForPanel.stage.x()) / DrawRoofForPanel.stage.scaleX();
            start.y = ((mousePos.y) - DrawRoofForPanel.stage.y()) / DrawRoofForPanel.stage.scaleY();
            //console.log('toptrianCircle start',start);
            DrawFence.selectPotionRect = false;
            if (con) {
                con.classList.add("sen-cursor-move");
            }

            position = "right";
        });

        btmlfttrianCircle.on("mousedown", (evt: any) => {
            //console.log('entered mousedown toptrianCircle');
            var mousePos: any = DrawRoofForPanel.stage.getPointerPosition();
            start.x = ((mousePos.x) - DrawRoofForPanel.stage.x()) / DrawRoofForPanel.stage.scaleX();
            start.y = ((mousePos.y) - DrawRoofForPanel.stage.y()) / DrawRoofForPanel.stage.scaleY();
            //zconsole.log('toptrianCircle start',start);
            DrawFence.selectPotionRect = false;
            if (con) {
                con.classList.add("sen-cursor-move");
            }

            position = "left";
        });

        //click and drag traingle point to the drag point
        DrawRoofForPanel.stage.on("mouseup", (event: any) => {
            //console.log('entered mouseup toptrianCircle');
            var mousePos: any = DrawRoofForPanel.stage.getPointerPosition();
            end.x = ((mousePos.x) - DrawRoofForPanel.stage.x()) / DrawRoofForPanel.stage.scaleX();// * DrawRoofForPanel.currentScale;
            end.y = ((mousePos.y) - DrawRoofForPanel.stage.y()) / DrawRoofForPanel.stage.scaleY();

            if (start.x > 0 && start.y > 0) {
                console.log('toptrianCircle end', end);
                DrawFence.selectPotionRect = true;

                const endX = end.x;
                const endY = end.y;
                if (con) {
                    con.classList.remove("sen-cursor-move");
                }

                DrawFence.updateShapeDetailForTriangleReshape(shape, endX, endY, position);

                start = {
                    x: 0,
                    y: 0
                };
                end = {
                    x: 0,
                    y: 0
                };
            } else {
                //on click roof clear obstruction text
                DrawFence.clearObstructionTextIfAlreadyPresent();
            }

        });

    }

    //update text with coordinates
    public static updateTextWithCoordinates(shape: any, textX1: any, textY1: any, textX2: any, textY2: any
        , textX3: any, textY3: any, textHeight: any, textWidth: any, textDiameter: any,
        centerPointCirle: any, toprectCircle: any, bottomrectCircle: any, toptrianCircle: any,
        btmlfttrianCircle: any, btmrgttrianCircle: any) {
        var stageX = DrawRoofForPanel.stage.x();
        var stageY = DrawRoofForPanel.stage.y();
        //console.log('stageX',stageX);
        //console.log('stageY',stageY);

        if (shape.getClassName() === "Line" && shape.getPoints().length == 6) {
            //console.log('triangle');
            DrawRoofForPanel.layerPanel.add(textX1, textY1, textX2, textY2, textX3, textY3, toptrianCircle, btmlfttrianCircle, btmrgttrianCircle);
            let points = shape.getPoints();
            const finalPoints: any = [];
            for (let i = 0; i < points.length; i = i + 2) {
                const pDiff: any = shape.getAbsoluteTransform().point({ x: points[i], y: points[i + 1] });
                finalPoints.push(pDiff.x / DrawRoofForPanel.currentScale);
                finalPoints.push(pDiff.y / DrawRoofForPanel.currentScale);
            }
            //points = finalPoints;
            var attrs = shape.getAttrs();

            //console.log('const attrs = shape.getClientRect();', attrs);
            //console.log('DrawRoofForPanel.currentScale', DrawRoofForPanel.currentScale);
            var x1 = ScaleAdjustmentValue.getOriginalValueWithOutScale(points[0]);
            var y1 = ScaleAdjustmentValue.getOriginalValueWithOutScale(points[1]);
            var x2 = ScaleAdjustmentValue.getOriginalValueWithOutScale(points[2]);
            var y2 = ScaleAdjustmentValue.getOriginalValueWithOutScale(points[3]);
            var x3 = ScaleAdjustmentValue.getOriginalValueWithOutScale(points[4]);
            var y3 = ScaleAdjustmentValue.getOriginalValueWithOutScale(points[5]);


            var p0 = finalPoints[0] - ScaleAdjustmentValue.reverseScale(stageX);//for getting the stage x value withpot scale
            var p1 = finalPoints[1] - ScaleAdjustmentValue.reverseScale(stageY);
            var p4 = finalPoints[4] - ScaleAdjustmentValue.reverseScale(stageX);
            var p5 = finalPoints[5] - ScaleAdjustmentValue.reverseScale(stageY);
            var p2 = finalPoints[2] - ScaleAdjustmentValue.reverseScale(stageX);
            var p3 = finalPoints[3] - ScaleAdjustmentValue.reverseScale(stageY);

            textX1.moveToTop();
            textY1.moveToTop();
            textX2.moveToTop();
            textY2.moveToTop();
            textX3.moveToTop();
            textY3.moveToTop();
            toptrianCircle.moveToTop();
            btmlfttrianCircle.moveToTop();
            btmrgttrianCircle.moveToTop();

            textX1.x(p0 + 30);
            textX1.y(p1 - 15);
            textY1.x(p0 + 30);
            textY1.y(p1 + 20);



            textX2.x(p2 + 15);
            textX2.y(p3 + 20);
            textY2.x(p2 + 15);
            textY2.y(p3 + 55);

            textX3.x(p4 - 120);
            textX3.y(p5 + 20);
            textY3.x(p4 - 120);
            textY3.y(p5 + 55);




            toptrianCircle.x(p0);
            toptrianCircle.y(p1);
            btmlfttrianCircle.x(p4);
            btmlfttrianCircle.y(p5);
            btmrgttrianCircle.x(p2);
            btmrgttrianCircle.y(p3);

            toptrianCircle.draw();
            btmlfttrianCircle.draw();
            btmrgttrianCircle.draw();





            var tx1: any = (x1 / 100).toFixed(2);
            var ty1: any = (y1 / 100).toFixed(2);
            var tx2: any = (x2 / 100).toFixed(2);
            var ty2: any = (y2 / 100).toFixed(2);
            var tx3: any = (x3 / 100).toFixed(2);
            var ty3: any = (y3 / 100).toFixed(2);

            if (window.localStorage.getItem("lng") == 'de') {

                tx1 = tx1.replace(".", ",");
                ty1 = ty1.replace(".", ",");
                tx2 = tx2.replace(".", ",");
                ty2 = ty2.replace(".", ",");
                tx3 = tx3.replace(".", ",");
                ty3 = ty3.replace(".", ",");
            }



            textX1.text("X : " + tx1 + " m");
            textY1.text("Y : " + ty1 + " m");
            textX2.text("X : " + tx2 + " m");
            textY2.text("Y : " + ty2 + " m");
            textX3.text("X : " + tx3 + " m");
            textY3.text("Y : " + ty3 + " m");
        } else if (shape.getClassName() === "Line" && shape.getPoints().length == 8) {
            //console.log('rectangle');
            DrawRoofForPanel.layerPanel.add(textX1, textY1, textX2, textY2, textWidth, textHeight, toprectCircle, bottomrectCircle);
            let points = shape.getPoints();
            const finalPoints: any = [];
            for (let i = 0; i < points.length; i = i + 2) {
                const pDiff: any = shape.getAbsoluteTransform().point({ x: points[i], y: points[i + 1] });
                finalPoints.push(pDiff.x / DrawRoofForPanel.currentScale);
                finalPoints.push(pDiff.y / DrawRoofForPanel.currentScale);
            }
            //points = finalPoints;
            const rect = shape.getClientRect();

            var width = parseInt(ScaleAdjustmentValue.reverseScale(rect.width) + "");
            var height = parseInt(ScaleAdjustmentValue.reverseScale(rect.height) + "");

            console.log('DrawRoofForPanel.currentScale', DrawRoofForPanel.stage.scaleX());
            var x1 = ScaleAdjustmentValue.getOriginalValueWithOutScale(points[0]);
            var y1 = ScaleAdjustmentValue.getOriginalValueWithOutScale(points[1]);
            var x2 = ScaleAdjustmentValue.getOriginalValueWithOutScale(points[4]);
            var y2 = ScaleAdjustmentValue.getOriginalValueWithOutScale(points[5]);

            var p0 = finalPoints[0] - ScaleAdjustmentValue.reverseScale(stageX);//for getting the stage x value withpot scale
            var p1 = finalPoints[1] - ScaleAdjustmentValue.reverseScale(stageY);
            var p2 = finalPoints[4] - ScaleAdjustmentValue.reverseScale(stageX);
            var p3 = finalPoints[5] - ScaleAdjustmentValue.reverseScale(stageY);

            textX1.moveToTop();
            textY1.moveToTop();
            textX2.moveToTop();
            textY2.moveToTop();
            textHeight.moveToTop();
            textWidth.moveToTop();
            //toprectCircle.moveToTop();
            //bottomrectCircle.moveToTop();

            textX1.x(p0 - 280);
            textX1.y(p1 - 20);
            textY1.x(p0 - 280);
            textY1.y(p1 + 15);

            textWidth.x(p0 - 280);
            textWidth.y(p1 + 50);

            textX2.x(p2 + 60);
            textX2.y(p3 - 20);
            textY2.x(p2 + 60);
            textY2.y(p3 + 15);

            textHeight.x(p2 + 60);
            textHeight.y(p3 + 50);
            toprectCircle.x(p0);
            toprectCircle.y(p1);
            bottomrectCircle.x(p2);
            bottomrectCircle.y(p3);

            console.log('x1', x1, typeof (x1));
            //var xx1: any =parseInt(x1.toString);
            var tx1: any = (x1 / 100).toFixed(2);
            var ty1: any = (y1 / 100).toFixed(2);
            var tx2: any = (x2 / 100).toFixed(2);
            var ty2: any = (y2 / 100).toFixed(2);
            var th: any = (height / 100).toFixed(2);
            var tw: any = (width / 100).toFixed(2);
            //tx1 =(x1 % 100).toFixed(0);
            //console.log('tx1',tx1);

            //var ty1 = (y1 % 100).toFixed(0);

            if (window.localStorage.getItem("lng") == 'de') {

                tx1 = tx1.replace(".", ",");
                ty1 = ty1.replace(".", ",");
                tx2 = tx2.replace(".", ",");
                ty2 = ty2.replace(".", ",");
                th = th.replace(".", ",");
                tw = tw.replace(".", ",");
            }
            textX1.text("X : " + tx1 + " m");
            textY1.text("Y : " + ty1 + " m");
            textX2.text("X : " + tx2 + " m");
            textY2.text("Y : " + ty2 + " m");
            textHeight.text("Height :" + th + " m");
            textWidth.text("Width :" + tw + " m");
            //console.log(textX1, textY1,textDiameter,textX2,textY2,textX3,textY3,textWidth,textHeight);


        } else {
            DrawRoofForPanel.layerPanel.add(textX1, textY1, textDiameter, centerPointCirle);
            textX1.moveToTop();
            textY1.moveToTop();
            textDiameter.moveToTop();
            centerPointCirle.moveToTop();
            const rect = shape.getClientRect();
            var attrs = shape.getAttrs();

            var x11 = attrs.x - 100;
            var y11 = attrs.y - 100;
            var diameter: any = ScaleAdjustmentValue.reverseScale(rect.width);
            var radius = ScaleAdjustmentValue.reverseScale(rect.width) / 2;
            var height = ScaleAdjustmentValue.reverseScale(rect.height) / 2;

            textX1.x(attrs.x - height - 60);
            textX1.y(attrs.y - height - 70);
            centerPointCirle.x(attrs.x);
            centerPointCirle.y(attrs.y);
            centerPointCirle.draw();
            //console.log('circle remove',ScaleAdjustmentValue.getOriginalValue(rect.x) + 100 );
            //toprectCircle.x(ScaleAdjustmentValue.getOriginalValue(rect.x) + 100 + (ScaleAdjustmentValue.reverseScale(rect.width) / 2));
            //toprectCircle.y(ScaleAdjustmentValue.getOriginalValue(rect.y) + 100 + (ScaleAdjustmentValue.reverseScale(rect.height)));
            //bottomrectCircle.x(p2);
            //bottomrectCircle.y(p3);


            textY1.x(attrs.x - height - 60);
            textY1.y(attrs.y - height - 35);

            textDiameter.x(attrs.x - height - 60);
            textDiameter.y(attrs.y - height);
            const calx = parseInt((x11 / 100) + " m");
            const caly = parseInt((y11 / 100) + " m");

            var tx1: any = (x11 / 100).toFixed(2);
            var ty1: any = (y11 / 100).toFixed(2);
            var tdiameter: any = (diameter / 100).toFixed(2);

            if (window.localStorage.getItem("lng") == 'de') {

                tx1 = tx1.replace(".", ",");
                ty1 = ty1.replace(".", ",");
                tdiameter = tdiameter.replace(".", ",");

            }

            textX1.text("X : " + tx1 + " m");
            textY1.text("Y : " + ty1 + " m");

            textDiameter.text("Diameter : " + tdiameter + " m");

        }

    }

    //clear shape if already present
    static clearObstructionTextIfAlreadyPresent() {

        var obj: any = DrawRoofForPanel.layerPanel.find(".obstructionText");

        //console.log('clearShapeIfAlreadyPresent',obj);
        if (obj && obj.length > 0)
            obj.forEach((item: any) => {
                item.remove();
            });

        var obj: any = DrawRoofForPanel.layerPanel.find(".obstructionCirclePoints");

        //console.log('clearShapeIfAlreadyPresent',obj);
        if (obj && obj.length > 0)
            obj.forEach((item: any) => {
                item.remove();
            });
        DrawRoofForPanel.layerPanel.draw();
    }

    static addTransformNodes(shape: any, textX1: any, textY1: any, textX2: any, textY2: any
        , textX3: any, textY3: any, textHeight: any, textWidth: any, textDiameter: any,
        centerPointCirle: any, toprectCircle: any, bottomrectCircle: any, toptrianCircle: any,
        btmlfttrianCircle: any, btmrgttrianCircle: any) {
        var stage = DrawRoofForPanel.stage;
        DrawFence.removeTransformNodes();
        var buttons: any = {};
        DrawFence.isTransformEnabled = true;
        const config = {
            rotateEnabled: true,
            name: "shapeTransform",
            enabledAnchors: ['top-left', 'top-center', 'bottom-center', 'middle-left', 'middle-right', 'top-right', 'bottom-left', 'bottom-right'],// for rectangle anchors,
            borderEnabled: true,
            anchorStroke: 'red',
            anchorFill: 'red',
            borderStroke: 'green',
            rotateAnchorOffset: 30,
            borderDash: [4, 3],
            anchorCornerRadius: 5,
            anchorStrokeWidth: 4,
            borderStrokeWidth: 1,

        }
        //for circle anchors
        if (shape.getClassName() === "Circle") {
            config.enabledAnchors = ['top-left', 'top-right', 'bottom-left', 'bottom-right'];
            config.rotateEnabled = false;
        }
        //console.log(shape.getClassName(),'shape.getClassName()');
        //for rectangle anchors
        if (shape.getClassName() === "Line" && shape.getPoints().length == 6) {
            config.enabledAnchors = [];
            config.borderEnabled = false;

        }

        const tr = new Konva.Transformer(config);

        //set button value after transform basic config
        if (shape.getClassName() === "Circle") {
            buttons = {
                //rotater: {
                //    path:'<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><title>box-configurator-rotate</title><circle cx="8" cy="8" r="8" style="fill:#fff"/><path d="M0.9,0.5c0.1,0,0.3,0.1,0.3,0.3L1.1,2.9c1-1.4,2.6-2.4,4.5-2.4c2.9,0,5.3,2.4,5.3,5.3c0,2.9-2.4,5.3-5.3,5.3c-1.4,0-2.6-0.5-3.6-1.4c-0.1-0.1-0.1-0.3,0-0.4L2.3,9c0.1-0.1,0.3-0.1,0.4,0c0.7,0.7,1.7,1.1,2.8,1.1c2.3,0,4.2-1.9,4.2-4.2S7.8,1.7,5.5,1.7c-1.7,0-3.2,1-3.8,2.5l2.7-0.1c0.1,0,0.3,0.1,0.3,0.3v0.6c0,0.1-0.1,0.3-0.3,0.3H0.3C0.1,5.2,0,5.1,0,4.9V0.8c0-0.1,0.1-0.3,0.3-0.3H0.9z"/></svg>',
                //   shape: tr.findOne('.rotater')
                // },

            };
        } else if (shape.getClassName() === "Line" && shape.getPoints().length == 8) {
            buttons = {
                // rotater: {
                //  path:'<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><title>box-configurator-rotate</title><circle cx="8" cy="8" r="8" style="fill:#fff"/><path d="M0.9,0.5c0.1,0,0.3,0.1,0.3,0.3L1.1,2.9c1-1.4,2.6-2.4,4.5-2.4c2.9,0,5.3,2.4,5.3,5.3c0,2.9-2.4,5.3-5.3,5.3c-1.4,0-2.6-0.5-3.6-1.4c-0.1-0.1-0.1-0.3,0-0.4L2.3,9c0.1-0.1,0.3-0.1,0.4,0c0.7,0.7,1.7,1.1,2.8,1.1c2.3,0,4.2-1.9,4.2-4.2S7.8,1.7,5.5,1.7c-1.7,0-3.2,1-3.8,2.5l2.7-0.1c0.1,0,0.3,0.1,0.3,0.3v0.6c0,0.1-0.1,0.3-0.3,0.3H0.3C0.1,5.2,0,5.1,0,4.9V0.8c0-0.1,0.1-0.3,0.3-0.3H0.9z"/></svg>',
                //   shape: tr.findOne('.rotater')
                // },


            };

        } else {
            buttons = {
                //rotater: {
                // path:'<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><title>box-configurator-rotate</title><circle cx="8" cy="8" r="8" style="fill:#fff"/><path d="M0.9,0.5c0.1,0,0.3,0.1,0.3,0.3L1.1,2.9c1-1.4,2.6-2.4,4.5-2.4c2.9,0,5.3,2.4,5.3,5.3c0,2.9-2.4,5.3-5.3,5.3c-1.4,0-2.6-0.5-3.6-1.4c-0.1-0.1-0.1-0.3,0-0.4L2.3,9c0.1-0.1,0.3-0.1,0.4,0c0.7,0.7,1.7,1.1,2.8,1.1c2.3,0,4.2-1.9,4.2-4.2S7.8,1.7,5.5,1.7c-1.7,0-3.2,1-3.8,2.5l2.7-0.1c0.1,0,0.3,0.1,0.3,0.3v0.6c0,0.1-0.1,0.3-0.3,0.3H0.3C0.1,5.2,0,5.1,0,4.9V0.8c0-0.1,0.1-0.3,0.3-0.3H0.9z"/></svg>',
                // shape: tr.findOne('.rotater')
                // },

            };

        }




        tr.nodes([shape]);
        //DrawFence.tr.attachTo(shape);

        DrawRoofForPanel.layerPanel.add(tr);


        tr.on("click", (e: any) => {
            e.cancelBubble = true;

        });


        //add customisation for konva transform



        for (var button in buttons) {
            var shape1 = buttons[button].shape;
            var selector = button.replace('_', '-');
            var icon = new Konva.Path({
                fill: "white",
                data: buttons[button].path,
                name: selector + '-icon',
                draggable: false
            });
            icon.position(shape1.position());
            icon.x(shape1.x() - 5.25);
            icon.y(shape1.y() - 5.25);
            tr.add(icon);
            DrawRoofForPanel.layerPanel.batchDraw();

        }

        tr.on('transform', function () {
            DrawFence.updateTextWithCoordinates(shape, textX1, textY1, textX2, textY2
                , textX3, textY3, textHeight, textWidth, textDiameter, centerPointCirle, toprectCircle
                , bottomrectCircle, toptrianCircle, btmlfttrianCircle, btmrgttrianCircle);
            tr.update();


            for (var button in buttons) {
                var selector = button.replace('_', '-');
                var shape2 = tr.findOne('.' + selector);
                var icon = tr.findOne('.' + selector + '-icon');

                icon.position(shape2.position());
                icon.x(shape2.x() - 5.25);
                icon.y(shape2.y() - 5.25);
                DrawRoofForPanel.layerPanel.batchDraw();
            }

        });

        tr.on('transformend', function (e: any) {
            DrawFence.clearPanelsForShape(null, null, shape);
        });



        tr.on("mousedown", (evt: any) => {
            evt.cancelBubble = true;
        });

        tr.on("mouseup", (evt: any) => {

        });


        DrawRoofForPanel.layerPanel.batchDraw();
    }
    static removeTransformNodes() {
        // var stage = DrawRoofForPanel.stage;
        var obj: any = DrawRoofForPanel.layerPanel.find(".shapeTransform");
        //console.log('removeTransformNodes',obj);
        if (obj && obj.length > 0)
            obj.forEach((item: any) => {
                item.destroy();
            });
        DrawRoofForPanel.layerPanel.draw();
        DrawFence.currentSelectedShape = null;
    }
    static updateShapeDetails(shape: any) {
        var shapeDetailsObj: any;
        const attrs = shape.getAttrs();
        const rect = shape.getClientRect();

        if (shape.getClassName() === "Line" && shape.getPoints().length == 8) {
            shapeDetailsObj = {
                name: shape.getId(),
                x1: ScaleAdjustmentValue.getOriginalValue(rect.x),
                y1: ScaleAdjustmentValue.getOriginalValue(rect.y),
                width: ScaleAdjustmentValue.reverseScale(rect.width),
                height: ScaleAdjustmentValue.reverseScale(rect.height),
            }
        }
        if (shape.getClassName() === "Line" && shape.getPoints().length == 6) {
            let p = shape.getPoints();
            const finalPoints: any = [];
            for (let i = 0; i < p.length; i = i + 2) {
                const pDiff: any = shape.getAbsoluteTransform().point({ x: p[i], y: p[i + 1] });
                finalPoints.push(pDiff.x / DrawRoofForPanel.currentScale);
                finalPoints.push(pDiff.y / DrawRoofForPanel.currentScale);
            }
            p = finalPoints;
            shapeDetailsObj = {
                name: shape.getId(),
                x1: ScaleAdjustmentValue.getOriginalValueWithOutScale(p[0]),
                y1: ScaleAdjustmentValue.getOriginalValueWithOutScale(p[1]),
                x2: ScaleAdjustmentValue.getOriginalValueWithOutScale(p[2]),
                y2: ScaleAdjustmentValue.getOriginalValueWithOutScale(p[3]),
                x3: ScaleAdjustmentValue.getOriginalValueWithOutScale(p[4]),
                y3: ScaleAdjustmentValue.getOriginalValueWithOutScale(p[5]),
            }
        }
        if (shape.getClassName() === "Circle") {
            shapeDetailsObj = {
                name: shape.getId(),
                x1: ScaleAdjustmentValue.getOriginalValue(rect.x) + ScaleAdjustmentValue.reverseScale(rect.width) / 2,
                y1: ScaleAdjustmentValue.getOriginalValue(rect.y) + ScaleAdjustmentValue.reverseScale(rect.width) / 2,
                radius: ScaleAdjustmentValue.reverseScale(rect.width) / 2
            }
        }
        new ShapeDetails(shapeDetailsObj);
        DrawFence.storeObj.dispatch(detailsOfNonUsableAreas({ show: new ShapeDetails(shapeDetailsObj) }));
    }
    static clearPanels() {
        const nonUsableArea: any = DrawRoofForPanel.layerPanel.find("." + Global.nonUsableArea);
        if (nonUsableArea && nonUsableArea.length > 0) {
            nonUsableArea.forEach((shape: any) => {
                if (!DrawFence.doClearPanels)
                    DrawFence.clearPanelsForShape(null, null, shape);
            });
            DrawRoofForPanel.layerPanel.batchDraw();

        }
    }
    static isEligibletoDraw(panel: any) {
        let isEligibletoDraw = true;
        const nonUsableArea: any = DrawRoofForPanel.layerPanel.find("." + Global.nonUsableArea);
        if (nonUsableArea && nonUsableArea.length > 0) {
            nonUsableArea.forEach((shape: any) => {
                var area: any;
                const attrs = shape.getAttrs();
                const rect = shape.getClientRect();

                if (shape.getClassName() === "Line" && shape.getPoints().length == 8) {

                    let p = shape.getPoints();
                    const finalPoints: any = [];
                    for (let i = 0; i < p.length; i = i + 2) {
                        const pDiff: any = shape.getAbsoluteTransform().point({ x: p[i], y: p[i + 1] });
                        const x = (pDiff.x - DrawRoofForPanel.stage.x()) / DrawRoofForPanel.stage.scaleX();
                        const y = (pDiff.y - DrawRoofForPanel.stage.y()) / DrawRoofForPanel.stage.scaleY();
                        finalPoints.push(x);
                        finalPoints.push(y);
                    }
                    p = finalPoints;

                    const rect1 = turf.polygon([
                        [
                            [p[0], p[1]],
                            [p[2], p[3]],
                            [p[4], p[5]],
                            [p[6], p[7]],
                            [p[0], p[1]]
                        ]
                    ]);
                    const rect2 = turf.polygon([
                        [
                            [panel.x, panel.y],
                            [panel.x + panel.width, panel.y],
                            [panel.x + panel.width, panel.y + panel.height],
                            [panel.x, panel.y + panel.height],
                            [panel.x, panel.y]
                        ]
                    ]);

                    if (turf.intersect(rect1, rect2) != null) {
                        isEligibletoDraw = false;
                    }
                }
                if (shape.getClassName() === "Line" && shape.getPoints().length == 6) {
                    let p = shape.getPoints();
                    const finalPoints: any = [];
                    for (let i = 0; i < p.length; i = i + 2) {
                        const pDiff: any = shape.getAbsoluteTransform().point({ x: p[i], y: p[i + 1] });
                        const x = (pDiff.x - DrawRoofForPanel.stage.x()) / DrawRoofForPanel.stage.scaleX();
                        const y = (pDiff.y - DrawRoofForPanel.stage.y()) / DrawRoofForPanel.stage.scaleY();
                        finalPoints.push(x);
                        finalPoints.push(y);
                    }
                    p = finalPoints;
                    let xMin: number = (p[0] < p[2] && p[0] < p[4]) ? p[0] : ((p[2] < p[0] && p[2] < p[4]) ? p[2] : p[4]);
                    let yMin: number = (p[1] < p[3] && p[1] < p[5]) ? p[1] : ((p[3] < p[1] && p[3] < p[5]) ? p[3] : p[5]);
                    let xMax: number = (p[0] > p[2] && p[0] > p[4]) ? p[0] : ((p[2] > p[0] && p[2] > p[4]) ? p[2] : p[4]);
                    let yMax: number = (p[1] > p[3] && p[1] > p[5]) ? p[1] : ((p[3] > p[1] && p[3] > p[5]) ? p[3] : p[5]);
                    xMin -= 200;
                    yMin -= 200;
                    xMax += 200;
                    yMax += 200;
                    if (panel.x > xMax || (panel.x + panel.width) < xMin || panel.y > yMax || (panel.y + panel.height) < yMin) {
                    } else {
                        isEligibletoDraw = this.PanelIsInFenceTriangle(p, panel);
                    }
                }
                if (shape.getClassName() === "Circle") {
                    const rect = shape.getClientRect();
                    const details = { ...shape.getAttrs() };
                    //check turf.ellipse(center, xSemiAxis, ySemiAxis); || Math.abs(shape.getRotation()) > 1)
                    const r = ScaleAdjustmentValue.reverseScale(rect.width) / 2;

                    const a = ScaleAdjustmentValue.reverseScale(rect.width) / 2;
                    const b = ScaleAdjustmentValue.reverseScale(rect.height) / 2;
                    var angle = shape.getRotation();
                    if (Math.abs(rect.height - rect.width) > 1) {

                        const a = ScaleAdjustmentValue.reverseScale(rect.width) / 2;
                        const b = ScaleAdjustmentValue.reverseScale(rect.height) / 2;


                        // if(angle < 0){
                        //    angle =  360 +  angle;
                        // }

                        // console.log('angle',angle);

                        // this.discretizeEllipse(details.x - 100, details.y - 100,a,b );
                        if (this.checkAllCornersOfPanelsForEllipse(panel, details.x - 100, details.y - 100, a, b, angle)) {

                            console.log('isInEllipse', panel, details.x, details.y, ScaleAdjustmentValue.reverseScale(rect.width) / 2, ScaleAdjustmentValue.reverseScale(rect.height) / 2);
                            isEligibletoDraw = false;

                        }



                    } else {
                        const details = { ...shape.getAttrs() };
                        details.radius = r;
                        if (this.checkAllCornersOfPanels(details, panel)) {
                            isEligibletoDraw = false;
                            //console.log('circle remove panels')
                        }

                    }
                }

            });
        }
        return isEligibletoDraw;
    }

    static checkAllCornersOfPanels(attrs: any, panel: any): boolean {



        let ht = 1;
        let wt = 1;
        const h = panel.height;
        const w = panel.width;
        const p = panel;
        let touched = false;
        while (ht <= h && !touched) {
            const p1: any = {
                x: p.x,
                y: p.y + ht,
            }
            touched = this.circleIntersection(attrs, p1);
            p1.x = p.x + w;
            if (!touched)
                touched = this.circleIntersection(attrs, p1);
            ht++;
            ht++;
        }
        while (wt <= w && !touched) {
            const p1: any = {
                x: p.x + wt,
                y: p.y,
            }
            touched = this.circleIntersection(attrs, p1);
            p1.y = p.y + h;
            if (!touched)
                touched = this.circleIntersection(attrs, p1);
            wt++;
            wt++;
        }
        return touched;
    }
    static circleIntersection(attrs: any, panel: any): boolean {

        const a: number = Math.abs(attrs.x - panel.x);
        const b: number = Math.abs(attrs.y - panel.y);
        // console.log('attrs.x,attrs.y',attrs.x,attrs.y,panel.x,panel.y);
        return (a ** 2 + b ** 2) < (attrs.radius ** 2);
    }



    static circleRectIntersect(attrs: any, panel: any) {

        // temporary variables to set edges for testing
        var testX = attrs.x;
        var testY = attrs.y;
        //panel.width, panel.y + panel.height]
        // which edge is closest?
        if (attrs.x < attrs.y)
            testX = panel.x;      // test left edge
        else if (attrs.x > panel.x + panel.width)
            testX = panel.x + panel.width;   // right edge
        if (attrs.y < panel.y)
            testY = panel.y;      // top edge
        else if (attrs.y > panel.y + panel.height)
            testY = panel.y + panel.height;   // bottom edge

        // get distance from closest edges
        var distX = attrs.x - testX;
        var distY = attrs.y - testY;
        var distance = Math.sqrt((distX * distX) + (distY * distY));

        // if the distance is less than the radius, collision!
        if (distance <= attrs.radius) {
            return true;
        }
        return false;
    }

    static PanelIsInFenceTriangle(trianglePoints: number[], panel: any): boolean {

        // console.log('PanelIsInFenceTriangle' ,trianglePoints);
        let isEligibletoDraw = true;
        const a = {
            x: trianglePoints[0],
            y: trianglePoints[1]
        }
        const b = {
            x: trianglePoints[2],
            y: trianglePoints[3]
        }
        const c = {
            x: trianglePoints[4],
            y: trianglePoints[5]
        }
        // top left
        const p = {
            x: panel.x,
            y: panel.y
        }
        isEligibletoDraw = !this.isPointInTriangle(p, a, b, c);
        if (!isEligibletoDraw) return isEligibletoDraw;

        // top right
        p.x = panel.x + panel.width;
        p.y = panel.y;
        isEligibletoDraw = !this.isPointInTriangle(p, a, b, c);
        if (!isEligibletoDraw) return isEligibletoDraw;

        // // bottom right
        p.x = panel.x + panel.width;
        p.y = panel.y + panel.height;
        isEligibletoDraw = !this.isPointInTriangle(p, a, b, c);
        if (!isEligibletoDraw) return isEligibletoDraw;

        // // bottom left
        p.x = panel.x;
        p.y = panel.y + panel.height;
        isEligibletoDraw = !this.isPointInTriangle(p, a, b, c);
        if (!isEligibletoDraw) return isEligibletoDraw;
        //
        p.x = panel.x;
        p.y = panel.y;
        if (isEligibletoDraw)
            isEligibletoDraw = !this.pointInTriangle(p, a, b, c, panel.width, panel.height);
        return isEligibletoDraw;
    }

    static pointInTriangle(p: any, a: any, b: any, c: any, w: any, h: any): boolean {
        let ht = 1;
        let wt = 1;
        let touched = false;
        while (ht <= h && !touched) {
            const p1: any = {
                x: p.x,
                y: p.y + ht,
            }
            touched = this.isPointInTriangle(p1, a, b, c);
            p1.x = p.x + w;
            if (!touched)
                touched = this.isPointInTriangle(p1, a, b, c);
            ht++;
            ht++;
        }
        while (wt <= w && !touched) {
            const p1: any = {
                x: p.x + wt,
                y: p.y,
            }
            touched = this.isPointInTriangle(p1, a, b, c);
            p1.y = p.y + h;
            if (!touched)
                touched = this.isPointInTriangle(p1, a, b, c);
            wt++;
            wt++;
        }
        return touched;
    }

    //FenceTriangle
    static isPointInTriangle(p: any, a: any, b: any, c: any): boolean {
        var s: number;
        var t: number;
        s = -((c.x - a.x) * p.y + (a.y - c.y) * p.x + a.x * c.y - a.y * c.x) / ((b.x - a.x) * c.y + (a.y - b.y) * c.x + a.x * b.y - a.y * b.x);
        t = (-((b.x - a.x) * s - p.x + a.x) / (c.x - a.x));
        return ((0 < s) && (s <= 1) && (0 < t) && (t <= 1) && (0 < (s + t)) && ((s + t) <= 1));
    }

    static clearPanelsForShape(start: any, end: any, shape: any) {
        let minY, maxY, minX, maxX;
        let isEligibletoDraw = true;
        //console.log('start',start,'end',end,'shape',shape);
        if (start == null) {
            if (shape.getClassName() === "Line") {
                let p = shape.getPoints();
                //console.log('p',p);
                const pattr = shape.getAttrs();
                const finalPoints: any = [];
                for (let i = 0; i < p.length; i = i + 2) {
                    const pDiff: any = shape.getAbsoluteTransform().point({ x: p[i], y: p[i + 1] });
                    const x = (pDiff.x - DrawRoofForPanel.stage.x()) / DrawRoofForPanel.stage.scaleX();
                    const y = (pDiff.y - DrawRoofForPanel.stage.y()) / DrawRoofForPanel.stage.scaleY();
                    finalPoints.push(x);
                    finalPoints.push(y);
                }
                p = finalPoints;
                const x = p.length == 6 ? [p[0], p[2], p[4]] : [p[0], p[2], p[4], p[6]];
                const y = p.length == 6 ? [p[1], p[3], p[5]] : [p[1], p[3], p[5], p[7]];

                minX = _.min(x) - 200;
                minY = _.min(y) - 200;
                maxX = _.max(x) + 200;
                maxY = _.max(y) + 200;

            } else {
                console.log('circle remove entered');
                const c = shape.getAttrs();
                minX = c.x - c.radius * (c.scaleX ? c.scaleX : 1);
                minY = c.y - c.radius * (c.scaleY ? c.scaleY : 1);
                maxX = c.x + c.radius * (c.scaleX ? c.scaleX : 1);
                maxY = c.y + c.radius * (c.scaleY ? c.scaleY : 1);
            }


        } else {
            minX = start.x < end.x ? start.x - 200 : end.x - 200;
            maxX = start.x < end.x ? end.x + 200 : start.x + 200;
            minY = start.y < end.y ? start.y - 200 : end.y - 200;
            maxY = start.y < end.y ? end.y + 200 : start.y + 200;
        }
        var obj: any = [];
        //console.log('ModList.listOfModules',ModList.listOfModules);
        if (ModList.listOfModules.length > 500)
            obj = getListbyBlocks(minY, maxY, minX, maxX);
        if (obj.length == 0) {
            obj = [...ModList.listOfModules]
        }

        const attrs = shape.getAttrs();
        //console.log('circle remove',obj);
        let count = 0;
        if (obj && obj.length > 0)
            obj.forEach((panel: any) => {
                //rectangle obstruction
                if (shape.getClassName() === "Line" && shape.getPoints().length == 8) {

                    let p = shape.getPoints();
                    //console.log('points',p);
                    const finalPoints: any = [];
                    for (let i = 0; i < p.length; i = i + 2) {
                        const pDiff: any = shape.getAbsoluteTransform().point({ x: p[i], y: p[i + 1] });
                        //console.log('pDiff',pDiff);
                        const x = (pDiff.x - DrawRoofForPanel.stage.x()) / DrawRoofForPanel.stage.scaleX();
                        const y = (pDiff.y - DrawRoofForPanel.stage.y()) / DrawRoofForPanel.stage.scaleY();
                        finalPoints.push(x);
                        finalPoints.push(y);
                    }
                    p = finalPoints;
                    // console.log('finalPoints',p);
                    const rect1 = turf.polygon([
                        [
                            [p[0], p[1]],
                            [p[2], p[3]],
                            [p[4], p[5]],
                            [p[6], p[7]],
                            [p[0], p[1]]
                        ]
                    ]);
                    const rect2 = turf.polygon([
                        [
                            [panel.x, panel.y],
                            [panel.x + panel.width, panel.y],
                            [panel.x + panel.width, panel.y + panel.height],
                            [panel.x, panel.y + panel.height],
                            [panel.x, panel.y]
                        ]
                    ]);

                    if (turf.intersect(rect1, rect2) != null) {
                        isEligibletoDraw = false;
                    }
                    // }
                }
                //triangle obstruction
                if (shape.getClassName() === "Line" && shape.getPoints().length == 6) {

                    let p = shape.getPoints();
                    const finalPoints: any = [];
                    for (let i = 0; i < p.length; i = i + 2) {
                        const pDiff: any = shape.getAbsoluteTransform().point({ x: p[i], y: p[i + 1] });
                        const x = (pDiff.x - DrawRoofForPanel.stage.x()) / DrawRoofForPanel.stage.scaleX();
                        const y = (pDiff.y - DrawRoofForPanel.stage.y()) / DrawRoofForPanel.stage.scaleY();
                        finalPoints.push(x);
                        finalPoints.push(y);
                    }
                    p = finalPoints;

                    isEligibletoDraw = this.PanelIsInFenceTriangle(p, panel);
                }
                //circle obstruction remove panel
                if (shape.getClassName() === "Circle") {

                    const rect = shape.getClientRect();
                    const r = ScaleAdjustmentValue.reverseScale(rect.width) / 2;



                    //  if (Math.abs(rect.height - rect.width) > 1 ) {
                    const details = { ...shape.getAttrs() };
                    details.radius = r;



                    const a = ScaleAdjustmentValue.reverseScale(rect.width) / 2;
                    const b = ScaleAdjustmentValue.reverseScale(rect.height) / 2;
                    var angle = shape.getRotation();



                    if (this.checkAllCornersOfPanelsForEllipse(panel, details.x - 100, details.y - 100, a, b, angle)) {

                        console.log('circle remove isInEllipse', panel, details.x, details.y, ScaleAdjustmentValue.reverseScale(rect.width) / 2, ScaleAdjustmentValue.reverseScale(rect.height) / 2);
                        isEligibletoDraw = false;

                    }
                    console.log('circle remove 1 isInEllipse');

                    // } else {
                    //const details = { ...shape.getAttrs() };
                    //details.radius = r;
                    // if (this.checkAllCornersOfPanels(details, panel)) {
                    //     isEligibletoDraw = false;
                    //     console.log('circle remove 2');
                    // }

                    // }


                }
                if (!isEligibletoDraw) {
                    const g: any = DrawRoofForPanel.layerPanel.find("#" + panel.id);
                    if (g && g.length > 0) g.forEach((i: any) => {
                        i.destroy();
                        count++;
                        isEligibletoDraw = true;
                    })
                }
            });

        DrawRoofForPanel.layerPanel.batchDraw();
        setTimeout(() => {
            //console.log('genaratePanelSave1 drawfence');
            genaratePanelSave();
        }, 1500);
    }


    static updateShapeDetailForTriangleReshape(shape: any, x: any, y: any, position: any) {
        var pq: number[] = [];
        let shapObj: any = null;
        var shapeDetailsObj: any;
        var stageX = DrawRoofForPanel.stage.x();

        if (shape.getClassName() === "Line" && shape.getPoints().length == 6) {
            //console.log('toptrianCircle shape.getClassName()',shape.getClassName());
            let p = shape.getPoints();
            const finalPoints: any = [];
            for (let i = 0; i < p.length; i = i + 2) {
                const pDiff: any = shape.getAbsoluteTransform().point({ x: p[i], y: p[i + 1] });
                finalPoints.push(pDiff.x / DrawRoofForPanel.currentScale);
                finalPoints.push(pDiff.y / DrawRoofForPanel.currentScale);
            }


            //console.log('DrawRoofForPanel.isZoomed ',DrawRoofForPanel.isZoomed);

            if (x == -9999 && y == -9999) {
                p = finalPoints;
                const pq: number[] = [
                    ScaleAdjustmentValue.getOriginalValueWithOutScaleWithoutStartingPoint(p[0]),
                    ScaleAdjustmentValue.getOriginalValueWithOutScaleWithoutStartingPoint(p[1]),
                    ScaleAdjustmentValue.getOriginalValueWithOutScaleWithoutStartingPoint(p[2]),
                    ScaleAdjustmentValue.getOriginalValueWithOutScaleWithoutStartingPoint(p[3]),
                    ScaleAdjustmentValue.getOriginalValueWithOutScaleWithoutStartingPoint(p[4]),
                    ScaleAdjustmentValue.getOriginalValueWithOutScaleWithoutStartingPoint(p[5]),
                ]

                shapObj = new FenceTriangle().getTriangle(null, null, shape.getId(), pq);

                //console.log('DrawRoofForPanel -9999 x and y');
            }
            else {
                //DrawFence.selectedShape.setPoints([p[0], p[1], p[2], p[3], p[4], w]);
                if (position == "top") {
                    //console.log('toptrianCircle position',position);
                    // shape.setPoints([x, y, p[2], p[3], p[4], p[5]]);


                    //- DrawRoofForPanel.stage.x() / ;
                    //start.y = ((mousePos.y) - DrawRoofForPanel.stage.y()) / DrawRoofForPanel.stage.scaleY();
                    // finalPoints[0] - ScaleAdjustmentValue.reverseScale(stageX);
                    if (DrawRoofForPanel.isZoomed) {
                        const finalPointss: any = [];
                        for (let i = 0; i < p.length; i = i + 2) {
                            const pDiff: any = shape.getAbsoluteTransform().point({ x: p[i], y: p[i + 1] });
                            const x = (pDiff.x - DrawRoofForPanel.stage.x()) / DrawRoofForPanel.stage.scaleX();
                            const y = (pDiff.y - DrawRoofForPanel.stage.y()) / DrawRoofForPanel.stage.scaleY();
                            finalPointss.push(x);
                            finalPointss.push(y);
                        }

                        p = finalPointss;
                        const pq: number[] = [
                            x,
                            y,
                            ScaleAdjustmentValue.getOriginalValueWithOutScaleWithoutStartingPoint(p[2]),
                            ScaleAdjustmentValue.getOriginalValueWithOutScaleWithoutStartingPoint(p[3]),
                            ScaleAdjustmentValue.getOriginalValueWithOutScaleWithoutStartingPoint(p[4]),
                            ScaleAdjustmentValue.getOriginalValueWithOutScaleWithoutStartingPoint(p[5]),

                        ]


                        shapObj = new FenceTriangle().getTriangle(null, null, shape.getId(), pq);
                    } else {
                        p = finalPoints;
                        const pq: number[] = [
                            x,
                            y,
                            ScaleAdjustmentValue.getOriginalValueWithOutScaleWithoutStartingPoint(p[2]),
                            ScaleAdjustmentValue.getOriginalValueWithOutScaleWithoutStartingPoint(p[3]),
                            ScaleAdjustmentValue.getOriginalValueWithOutScaleWithoutStartingPoint(p[4]),
                            ScaleAdjustmentValue.getOriginalValueWithOutScaleWithoutStartingPoint(p[5]),
                        ]

                        //console.log('toptrianCircle pq',pq);
                        shapObj = new FenceTriangle().getTriangle(null, null, shape.getId(), pq);
                    }

                } else if (position == "left") {

                    //shape.setPoints([p[0], p[1], p[2], p[3], x,y]);

                    if (DrawRoofForPanel.isZoomed) {
                        const finalPointss: any = [];
                        for (let i = 0; i < p.length; i = i + 2) {
                            const pDiff: any = shape.getAbsoluteTransform().point({ x: p[i], y: p[i + 1] });
                            const x = (pDiff.x - DrawRoofForPanel.stage.x()) / DrawRoofForPanel.stage.scaleX();
                            const y = (pDiff.y - DrawRoofForPanel.stage.y()) / DrawRoofForPanel.stage.scaleY();
                            finalPointss.push(x);
                            finalPointss.push(y);
                        }

                        p = finalPointss;
                        const pq: number[] = [
                            ScaleAdjustmentValue.getOriginalValueWithOutScaleWithoutStartingPoint(p[0]),
                            ScaleAdjustmentValue.getOriginalValueWithOutScaleWithoutStartingPoint(p[1]),
                            ScaleAdjustmentValue.getOriginalValueWithOutScaleWithoutStartingPoint(p[2]),
                            ScaleAdjustmentValue.getOriginalValueWithOutScaleWithoutStartingPoint(p[3]),
                            x,
                            y,
                        ]

                        //console.log('toptrianCircle pq',pq);
                        shapObj = new FenceTriangle().getTriangle(null, null, shape.getId(), pq);
                    } else {
                        p = finalPoints;
                        const pq: number[] = [
                            ScaleAdjustmentValue.getOriginalValueWithOutScaleWithoutStartingPoint(p[0]),
                            ScaleAdjustmentValue.getOriginalValueWithOutScaleWithoutStartingPoint(p[1]),
                            ScaleAdjustmentValue.getOriginalValueWithOutScaleWithoutStartingPoint(p[2]),
                            ScaleAdjustmentValue.getOriginalValueWithOutScaleWithoutStartingPoint(p[3]),
                            x,
                            y,
                        ]

                        //console.log('toptrianCircle pq',pq);
                        shapObj = new FenceTriangle().getTriangle(null, null, shape.getId(), pq);
                    }

                } else {

                    if (DrawRoofForPanel.isZoomed) {
                        const finalPointss: any = [];
                        for (let i = 0; i < p.length; i = i + 2) {
                            const pDiff: any = shape.getAbsoluteTransform().point({ x: p[i], y: p[i + 1] });
                            const x = (pDiff.x - DrawRoofForPanel.stage.x()) / DrawRoofForPanel.stage.scaleX();
                            const y = (pDiff.y - DrawRoofForPanel.stage.y()) / DrawRoofForPanel.stage.scaleY();
                            finalPointss.push(x);
                            finalPointss.push(y);
                        }

                        p = finalPointss;
                        const pq: number[] = [
                            ScaleAdjustmentValue.getOriginalValueWithOutScaleWithoutStartingPoint(p[0]),
                            ScaleAdjustmentValue.getOriginalValueWithOutScaleWithoutStartingPoint(p[1]),
                            x,
                            y,
                            ScaleAdjustmentValue.getOriginalValueWithOutScaleWithoutStartingPoint(p[4]),
                            ScaleAdjustmentValue.getOriginalValueWithOutScaleWithoutStartingPoint(p[5]),
                        ]
                        // shape.setPoints([p[0], p[1], x,y, p[4],p[5]]);
                        shapObj = new FenceTriangle().getTriangle(null, null, shape.getId(), pq);
                    } else {
                        p = finalPoints;
                        const pq: number[] = [
                            ScaleAdjustmentValue.getOriginalValueWithOutScaleWithoutStartingPoint(p[0]),
                            ScaleAdjustmentValue.getOriginalValueWithOutScaleWithoutStartingPoint(p[1]),
                            x,
                            y,
                            ScaleAdjustmentValue.getOriginalValueWithOutScaleWithoutStartingPoint(p[4]),
                            ScaleAdjustmentValue.getOriginalValueWithOutScaleWithoutStartingPoint(p[5]),
                        ]
                        // shape.setPoints([p[0], p[1], x,y, p[4],p[5]]);
                        shapObj = new FenceTriangle().getTriangle(null, null, shape.getId(), pq);
                    }


                    //console.log('toptrianCircle pq',pq);
                }


            }

            if (shape) {
                shape.destroy();
                //console.log('toptrianCircle shape',shape)
            }
            if (shapObj) {
                // console.log('toptrianCircle shapObj',shapObj)
                DrawFence.bindEventsForShape(shapObj);
                DrawRoofForPanel.layerPanel.add(shapObj);
                DrawFence.clearPanelsForShape(null, null, shapObj);
            }

            //saving globally to maintain prev and next state 
            saveNonUsableAreas();
            this.clearObstructionTextIfAlreadyPresent();
            // new ShapeDetails(shapeDetailsObj);
            // DrawFence.storeObj.dispatch(detailsOfNonUsableAreas({ show: new ShapeDetails(shapeDetailsObj) }));
            DrawFence.clearPanels();
            DrawRoofForPanel.layerPanel.draw();
            this.removeTransformNodes();

        }


    }



    static isInEllipse(panel: any, x: any, y: any, a: any, b: any, angle: any): boolean {

        var isTouched = false;
        var panelx = panel.x - 100;
        var panely = panel.y - 100;
        var dx = panelx - x;
        var dy = panely - y;

        if (angle == 0) {
            isTouched = ((dx * dx) / (a * a) + (dy * dy) / (b * b) <= 1);
            // console.log('isInEllipse angle' ,angle ,isTouched ,panel);
            //console.log('isInEllipse ellipse 1');

        }
        else {
            //angle = - angle;
            //isTouched = ( (((dx * (Math.cos(angle)) + dy * (Math.sin(angle)) ) * (dx * (Math.cos(angle)) + dy * (Math.sin(angle)) ) ) / (a *a)  )
            //+ (((dx * (Math.sin(angle)) - dy * (Math.cos(angle))) * (dx * (Math.sin(angle)) - dy * (Math.cos(angle)))) / (b* b)) <= 1 );
            isTouched = (((a * a) * (Math.pow(Math.sin(angle), 2)) + b * b * (Math.pow(Math.cos(angle), 2))) * dx * dx + 2 * (b * b - a * a) * (Math.sin(angle)) * (Math.cos(angle)) * (dx * dy) + ((a * a) * (Math.pow(Math.cos(angle), 2)) + (b * b) * (Math.pow(Math.sin(angle), 2))) * (dy * dy) <= a * a * b * b);
            //console.log('isInEllipse 1 angle' ,angle , isTouched,panel);
            //console.log('isInEllipse ellipse 3');
        }


        return isTouched;
    }


    static checkAllCornersOfPanelsForEllipse(panel: any, x: any, y: any, width: any, height: any, angle: any): boolean {
        let ht = 1;
        let wt = 1;
        const h = panel.height;
        const w = panel.width;
        const p = panel;
        let touched = false;
        while (ht <= h && !touched) {
            var p1: any = {
                x: p.x,
                y: p.y + ht,
            }
            // console.log('isInEllipse 1',touched,panel);
            touched = this.isInEllipse(p1, x, y, width, height, angle);
            p1.x = p.x + w;
            if (!touched) {
                //console.log('isInEllipse 2',touched,panel);
                touched = this.isInEllipse(p1, x, y, width, height, angle);
            }

            ht++;
            ht++;
        }
        while (wt <= w && !touched) {
            var p1: any = {
                x: p.x + wt,
                y: p.y,
            }
            //console.log('isInEllipse 3',touched,panel);
            touched = this.isInEllipse(p1, x, y, width, height, angle);
            p1.y = p.y + h;
            if (!touched) {
                // console.log('isInEllipse 4',touched,panel);
                touched = this.isInEllipse(p1, x, y, width, height, angle);
            }

            wt++;
            wt++;
        }
        //console.log('isInEllipse',touched,panel);
        return touched;
    }
};


